import axios from 'axios'
import { baseUrl } from '@/utils/baseUrl'
import { debounce } from '@/utils/tools'
import router from '@/router'
import { ElMessage } from 'element-plus'
function ElMessageFn() {
  return ElMessage({
    message: '后台服务器开小差啦~',
    type: 'error',
    showClose: true
  })
}
const debounceMessage = debounce(ElMessageFn, 500)
// create an axios instance
const service = axios.create({
  baseURL: baseUrl, // url = base url + request url
  timeout: 20000 // request timeout
})
const userLang = navigator.language
console.log(userLang, '555555555555555') // 例如: "zh-CN", "en-US"

service.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token')
    config.headers['platform'] = 'web'
    config.headers['productCode'] = 'photovoltaic'
    config.headers['product_code'] = 'photovoltaic'

    if (token && config.headers.Authorization === undefined) {
      config.headers.Authorization = token
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  (response) => {
    const res = response.data
    if (!res.errorCode) {
      if (res.code == '600') {
        sessionStorage.removeItem('token')
        router.replace('/login')
      }
      return res
    } else if (res.errorCode == '401') {
      debounceMessage()
      sessionStorage.removeItem('token')
      router.replace('/login')
      const yctmp = setTimeout(() => {
        document.location.reload()
        clearTimeout(yctmp)
      }, 100)
      return Promise.resolve(res)
    } else {
      ElMessage({
        message:
          (res.errorMessage?.length || 101) > 100
            ? '错误码：' + res.errorCode
            : res.errorMessage,
        type: 'error',
        showClose: true
      })
      return Promise.reject(res)
    }
  },
  (error) => {
    if (error.response) {
      //5xx错误提醒
      //4xx过期，清除token,跳转到登录页
      if (error?.response?.status == 500) {
        ElMessage({
          message: userLang == 'zh_CN' ? '服务器故障！' : 'Server Error!',
          type: 'error',
          showClose: true
        })
        return Promise.reject(error)
      } else if (error?.response?.status == 400) {
        ElMessage({
          message: userLang == 'zh_CN' ? '请求错误！' : 'Bad Request!',
          type: 'error',
          showClose: true
        })
        return Promise.reject(error)
      } else if (error?.response?.status == 401) {
        debounceMessage()
        sessionStorage.removeItem('token')
        router.replace('/login')
        const yc = setTimeout(() => {
          document.location.reload()
          clearTimeout(yc)
        }, 100)
        return Promise.reject(error)
      } else {
        ElMessage({
          message: userLang == 'zh_CN' ? '请求失败!' : 'Request Failed!',
          type: 'error',
          showClose: true
        })
      }
    } else if (error.request) {
      ElMessage({
        message: userLang == 'zh_CN' ? '请求超时！' : 'Request Timeout!',
        type: 'error',
        showClose: true
      })
      return Promise.reject(error)
    } else {
      ElMessage({
        message: error.message,
        type: 'error',
        showClose: true
      })
      return Promise.reject(error)
    }
  }
)

export default service
